import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { MatchStandings } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MatchStandingsService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingMatchStandings = signal<boolean>(false);
  isErrorMatchStandings = signal<boolean>(false);
  matchStandings = signal<MatchStandings | null>(null);

  constructor() {}

  getMatchStandings(matchId: String) {
    this.isLoadingMatchStandings.set(true);
    this.isErrorMatchStandings.set(false);

    this.http
      .get<MatchStandings | null>(
        `${this.env.baseUrlWeb}/matches/${matchId}/standings`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingMatchStandings.set(false);
          this.isErrorMatchStandings.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.matchStandings.set(null);
          return;
        }

        this.matchStandings.set(data);
        this.isLoadingMatchStandings.set(false);
      });
  }
}
